import { useGlobalContext } from '../context'
import { BsHandThumbsUp } from 'react-icons/bs'

export default function Meals() {
  const {loading, meals, selectMeal, addToFavorites} = useGlobalContext()
  if (loading) {
    return (
      <section className='section'>
        <h4>Loading...</h4>
      </section>
    )
  }

  if (meals.length < 1) {
    return (
      <section className='section'>
        <h4>No meals matched your search term. Please try again.</h4>
      </section>
    )
  }

  return (
    <section className='section-center'>
    {meals.map((meal) => {
      const { idMeal: id, strMeal:title, strMealThumb: image } = meal
      {/* console.log(meal) */}
      return (
        <article key={id} className='single-meal'>
          <img src={image} className='img' onClick={()=>selectMeal(id)}/>
          <footer>
            <h5>{title}</h5>
            <button className='like-btn' onClick={()=>addToFavorites(id)}><BsHandThumbsUp /></button>
          </footer>
        </article>
      )
    })}
    </section>
  )
}
